module.exports = __webpack_public_path__ + "media/images/icon-bw-facebook@2x-16fa26c63c9d584bcc694a56ba37a379.png";